// ================= ProfDashboard.jsx =================
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProfSidebar = () => {
  const navigate = useNavigate();
  const items = [
    { name: 'Créer examen', path: '/prof/create-exam' },
    { name: 'Gérer examens', path: '/prof/manage-exams' },
    { name: 'Mes cours', path: '/prof/manage-exams' },
    { name: 'Mes horaires', path: '/prof/manage-exams' },
        { name: "Notifications", path: "/notifications" },
    { name: 'Profil', path: '/profProfile' },
    { name: 'Déconnexion', path: '/logout' },
  ];

  return (
    <div style={styles.sidebar}>
      {items.map((item, idx) => (
        <div key={idx} style={styles.sidebarItem} onClick={() => navigate(item.path)}>
          {item.name}
        </div>
      ))}
    </div>
  );
};

const ProfDashboard = ({ user }) => {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    // Simulation fetch sessions
    setSessions([
      { name: 'Mathématiques', date: '2026-04-10', duration: 60 },
      { name: 'Physique', date: '2026-04-12', duration: 45 },
    ]);
  }, []);

  return (
    <div style={styles.container}>
      <ProfSidebar />
      <div style={styles.mainContent}>
        <h1>Bienvenue, {user?.fullname}</h1>
        <h2>Mes examens</h2>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Nom de l'examen</th>
              <th>Date</th>
              <th>Durée</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((exam, idx) => (
              <tr key={idx}>
                <td>{exam.name}</td>
                <td>{exam.date}</td>
                <td>{exam.duration} min</td>
                <td>
                  <button style={styles.actionBtn}>Modifier</button>
                  <button style={{...styles.actionBtn, backgroundColor: '#dc2626'}}>Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProfDashboard;

const styles = {
  container: { display: 'flex', minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif' },
  sidebar: { width: '220px', backgroundColor: '#1e3a8a', color: '#fff', padding: '20px', display: 'flex', flexDirection: 'column' },
  sidebarItem: { padding: '12px', marginBottom: '10px', borderRadius: '8px', cursor: 'pointer', backgroundColor: '#2563eb' },
  mainContent: { flex: 1, padding: '30px', backgroundColor: '#f8fafc' },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: '20px' },
  actionBtn: { padding: '6px 12px', marginRight: '8px', border: 'none', borderRadius: '6px', backgroundColor: '#2563eb', color: '#fff', cursor: 'pointer' },
};
